import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  "data-testid": "help-center-page",
  class: "flex flex-col w-full h-full"
}
const _hoisted_2 = {
  key: 0,
  "data-testid": "help-center-error",
  class: "flex flex-col items-center justify-center w-full h-full gap-y-4"
}
const _hoisted_3 = { class: "text-red-lp-200 text-sm text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isError)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("p", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1),
          _createVNode(_component_lp_button, {
            "data-testid": "help-center-error-button-retry",
            title: _ctx.$t('Coba lagi'),
            textColor: "white",
            onClick: _ctx.onRetry
          }, null, 8, ["title", "onClick"])
        ]))
      : (_ctx.iframeSrc)
        ? (_openBlock(), _createBlock("iframe", {
            key: 1,
            ref: "iframeEl",
            "data-testid": "help-center-iframe",
            src: _ctx.iframeSrc,
            title: _ctx.$t('breadcrumb.helpCenter'),
            class: "w-full flex-1 min-h-0 border-0",
            style: {"min-height":"100vh"},
            allow: "fullscreen; clipboard-write",
            onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onIframeLoaded && _ctx.onIframeLoaded(...args)))
          }, null, 40, ["src", "title"]))
        : _createCommentVNode("", true)
  ]))
}